import { render } from "./DouyinCard.vue?vue&type=template&id=4a49bc2a&scoped=true"
import script from "./DouyinCard.vue?vue&type=script&lang=js"
export * from "./DouyinCard.vue?vue&type=script&lang=js"

import "./DouyinCard.vue?vue&type=style&index=0&id=4a49bc2a&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a49bc2a"]])

export default __exports__